<template>
  <Vue3Lottie :animationData="animationData" :height="100" :width="100"></Vue3Lottie>
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import * as animationData from "../../assets/data.json";

export default {
  components: {
    Vue3Lottie
  },
  data() {
    return {
      animationData
    }
  }
}
</script>
